import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  hasStarted: false,
  currentIndex: 0,
  mode: 'free',
  items: [
    {
      name: 'Gramophone',
      isFound: false,
    },
    {
      name: 'Horse',
      isFound: false,
    },
    {
      name: 'Television',
      isFound: false,
    },
    {
      name: 'Pot',
      isFound: false,
    },
    {
      name: 'MusicBox',
      isFound: false,
    },
  ],
  hasFinished: false,
}

export const progressSlice = createSlice({
  name: 'progress',
  initialState,
  reducers: {
    startExperience(state) {
      state.hasStarted = true
    },
    setMode(state, action) {
      state.mode = action.payload
    },
    findItem(state, action) {
      state.mode = 'inspection'
      state.items[action.payload].isFound = true
    },
    goNext(state) {
      if (state.currentIndex !== state.items.length) {
        console.log('goNext')
        state.currentIndex++
        state.mode = 'free'
      } else {
        state.hasFinished = true
      }
    },
  },
})

export const { startExperience, setMode, findItem, goNext } =
  progressSlice.actions

export default progressSlice.reducer
